module.exports = __webpack_public_path__ + "static/media/user_remove.fd7c2125.svg";